import { PayloadAction } from "@reduxjs/toolkit";
import { ProposalInformationType, ProposalReduxState } from "../types";

// Overrides Proposal state
const SetProposalInfo = (
  state: ProposalReduxState,
  { payload }: PayloadAction<ProposalReduxState>,
) => {
  state = payload;
  state.isUpdated = true;
  return state;
};

// Update Proposal State
const UpdateProposalInfo = <K extends keyof ProposalReduxState>(
  state: ProposalReduxState,
  {
    payload: { key, value, update = true },
  }: PayloadAction<{
    key: K;
    value: ProposalReduxState[K];
    update?: boolean;
  }>,
) => {
  if (update) {
    state.isUpdated = true;
  }
  state[key] = value;
};

// Update Proposal Information Field
const UpdateProposalInfoField = <K extends keyof ProposalInformationType>(
  state: ProposalReduxState,
  {
    payload: { key, value, update = true },
  }: PayloadAction<{
    key: K;
    value: ProposalInformationType[K];
    update?: boolean;
  }>,
) => {
  if (update) {
    state.isUpdated = true;
  }
  state.proposalInformation[key] = value;
};

// Update Price Nets
const UpdateProductPriceNet = (
  state: ProposalReduxState,
  {
    payload: { id, volume, value },
  }: PayloadAction<{ id: string; volume: number; value: number }>,
) => {
  if (!state.priceNetById) state.priceNetById = {};
  state.priceNetById[id] = { volume, value };
};

const InfoReducers = {
  SetProposalInfo,
  UpdateProposalInfo,
  UpdateProposalInfoField,
  UpdateProductPriceNet,
};

export default InfoReducers;
